export default function Success({message}) {
	return (
		<div className="alert alert-success" role="alert">
			{message}
		</div>
	);
};
